import * as React from 'react';
import { connect } from 'react-redux';
import { removeVehicleFromPolicy, setQuoteCancellationReasons } from '../../../actions/salesActions';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';


class CancelCoverReasons extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handlePrimaryReasonSelection = this.handlePrimaryReasonSelection.bind(this);
        this.handleSecondaryReasonSelection = this.handleSecondaryReasonSelection.bind(this);
        this.handleRemoveCover = this.handleRemoveCover.bind(this);
        this.state = {
            showSecond : false
        }
    }

    async handlePrimaryReasonSelection(e: any) {
        await this.setState({showSecond : false})
        await this.props.dispatchSetQuoteCancellationReasons(e, undefined)
        await this.setState({ showSecond: true })
    }

    async handleSecondaryReasonSelection(e: any) {
        this.props.dispatchSetQuoteCancellationReasons(-1, e)
    }

    async handleRemoveCover(e: any) {
        await this.props.dispatchRemoveCarFromPolicy();
    }

    public render() {
        let selectedPrimaryReason = "";

        let secondaryReasonData = [];
        if (this.props.sales.primaryQuoteCancellationReason) {
            selectedPrimaryReason = this.props.sales.primaryQuoteCancellationReason
            secondaryReasonData = this.props.sales.quoteCancellationReasons.secondaryCancellationReasons.filter(x => x.primaryCancellationReasonId == Number(selectedPrimaryReason))
        }
        const isMobile = window.innerWidth <= 975;

        return <>
            <div className="row noma">
                <div className="col-12 nopa">
                    <h3>Remove cover</h3>
                    <p>To finalise the removal, please answer the following</p>
                </div>
            </div>
            <div className="row noma mr-20px">
                <div className="col-12 nopa mb-25px pl-0 pr-0">
                    <KPDropdown
                        id={"primary-cancellation-reason"}
                        isImageDropdown={false}
                        showLabelAfterSelection={true}
                        showLabelInside={true}
                        showLabelOutside={false}
                        isRiskItem={true}
                        labelAfterSelection={"Reason for removal"}
                        title={"Reason for removal"}
                        label={"Reason for removal"}
                        data={this.props.sales.quoteCancellationReasons.primaryCancellationReasons}
                        handleSelection={(e) => this.handlePrimaryReasonSelection(e)}
                        selectedValue={Number(this.props.sales.primaryQuoteCancellationReason) ? this.props.sales.quoteCancellationReasons.primaryCancellationReasons.filter(x => x.id == Number(this.props.sales.primaryQuoteCancellationReason))[0].description : ""}
                    />
                </div>
                {this.props.sales.primaryQuoteCancellationReason && this.state.showSecond &&
                    <div className="col-12 nopa mb-25px pl-0 pr-0">
                        <KPDropdown
                            id={"primary-cancellation-reason"}
                            isImageDropdown={false}
                            showLabelAfterSelection={true}
                            showLabelInside={true}
                            showLabelOutside={false}
                            isRiskItem={false}
                            labelAfterSelection={"Please tell us more"}
                            title={"Please tell us more"}
                            label={"Please tell us more"}
                            data={secondaryReasonData}
                            handleSelection={(e) => this.handleSecondaryReasonSelection(e)}
                            selectedValue={Number(this.props.sales.secondaryQuoteCancellationReason) ? this.props.sales.quoteCancellationReasons.secondaryCancellationReasons.filter(x => x.id == Number(this.props.sales.secondaryQuoteCancellationReason))[0].description : ""}
                        />
                    </div>
                }
            </div>
            <div className="row mb-5">
                <div className={"col text-right" + (isMobile ? " mr-20px" : "")}>
                    <button disabled={this.props.sales.secondaryQuoteCancellationReason === undefined} className={"btn btn-outline-red align-self-center mb-20px" + (isMobile ? " w-100 remove-cover-mobile" : " remove-cover mr-20px")} type="button" onClick={this.handleRemoveCover} >Remove cover</button>
                </div>
            </div>
        </>;
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetQuoteCancellationReasons: (primary, secondary) => dispatch(setQuoteCancellationReasons(primary, secondary)),
        dispatchRemoveCarFromPolicy: () => dispatch(removeVehicleFromPolicy()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelCoverReasons);
